import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiClient } from "@/lib/api";
import { ADMIN } from "@/constants/testIds";
import { toast } from "sonner";
import Starfield from "@/components/Starfield";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await apiClient.post("/auth/login", { email, password });
      localStorage.setItem("rb_admin_token", data.token);
      localStorage.setItem("rb_admin_email", data.email);
      toast.success("Welcome back ✦");
      nav("/admin");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Invalid credentials");
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="relative min-h-[80vh] flex items-center justify-center px-6">
      <Starfield density={30} dustDensity={10} />
      <form onSubmit={submit} className="relative z-10 w-full max-w-md glass-strong p-10 rounded-sm">
        <div className="text-center mb-8">
          <div className="tracking-celestial text-[var(--rb-gold)] mb-2">Studio entrance</div>
          <h1 className="font-serif-display text-3xl text-[var(--rb-text-heading)]">For the artisan.</h1>
        </div>
        <label className="rb-label">Email</label>
        <input className="rb-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid={ADMIN.loginEmail} required />
        <div className="h-4"/>
        <label className="rb-label">Password</label>
        <input className="rb-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid={ADMIN.loginPassword} required />
        <button type="submit" disabled={busy} className="btn-gold mt-8 w-full justify-center" data-testid={ADMIN.loginBtn}>
          {busy ? "Opening doors…" : "Enter studio"}
        </button>
      </form>
    </main>
  );
}
